{
  "feedback-process-pages": {
    "feedback-process-steps": {
      "step-1": {
        "title": "Sự hài lòng của bạn",
        "description": "Bạn có hài lòng với dịch vụ của chúng tôi không"
      },
      "step-2": {
        "title": "Thông tin phản hồi của bạn",
        "description": "Viết phản hồi của bạn"
      },
      "step-3": {
        "title": "Đã gửi phản hồi",
        "description": "Phản hồi của bạn đã được gửi"
      }
    },
    "meta": {
      "title": "Phản hồi",
      "description": "Phản hồi của bạn"
    }
  }
}
